export enum BuyingCenterContactDimensionsEnum {
  ACCURACY_TIER = "ACCURACY_TIER",
  DEPARTMENT = "DEPARTMENT",
  JOB_LEVEL = "JOB_LEVEL",
  OPPORTUNITY_STAGE = "OPPORTUNITY_STAGE",
  OPPORTUNITY_TYPE = "OPPORTUNITY_TYPE",
}

export const BuyingCenterContactDimensionsTitles = {
  [BuyingCenterContactDimensionsEnum.ACCURACY_TIER]: 'Accuracy Tier',
  [BuyingCenterContactDimensionsEnum.DEPARTMENT]: 'Department',
  [BuyingCenterContactDimensionsEnum.JOB_LEVEL]: 'Job Level',
  [BuyingCenterContactDimensionsEnum.OPPORTUNITY_STAGE]: 'Deal Stage',
  [BuyingCenterContactDimensionsEnum.OPPORTUNITY_TYPE]: 'Deal Type',
}
